import { Suspense, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LoadingSpinner } from "../../../../../../router/LoadingSpinner";
import { lazyWithRetry } from "../../../../../../utils/lazyWithRetry";
import Tabs from "./Tabs";

const Ratings = lazyWithRetry(() => import("./Ratings"));
const Valuation = lazyWithRetry(() => import("./Valuation"));

export type RatingSubView = "forecast" | "valuation";

type RatingTabProps = {
  ratingView: RatingSubView;
  onRatingViewChange: (view: RatingSubView) => void;
};

export default function RatingTab({
  ratingView,
  onRatingViewChange,
}: RatingTabProps) {
  const { t } = useTranslation();

  const items = useMemo(
    () => [
      {
        key: "forecast",
        label: t("pages.stock.tabs.forecast"),
        children: (
          <Suspense fallback={<LoadingSpinner />}>
            <Ratings />
          </Suspense>
        ),
      },
      {
        key: "valuation",
        label: t("pages.stock.tabs.valuation"),
        children: (
          <Suspense fallback={<LoadingSpinner />}>
            <Valuation />
          </Suspense>
        ),
      },
    ],
    [t],
  );

  return (
    <Tabs
      activeKey={ratingView}
      items={items}
      onChange={(key) => onRatingViewChange(key as RatingSubView)}
      destroyOnHidden
    />
  );
}
